export const menu = {
  mainMenu: '主選單',
  profile: '個人資料',
  settings: '設定',
  auditLogs: '稽核日誌',
  operations: '營運管理',
  chargerManagement: '充電樁管理',
  chargerFirmware: '充電樁韌體',
  firmwareUpdates: '韌體更新',
  vendorManagement: '商戶管理',
  kiosk: '付款亭',
  vehicleCatalog: '車輛型錄',
  chargingManagement: '充電管理',
  activeSessions: '使用中時段',
  chargingHistory: '充電歷史',
  userManagement: '使用者管理',
  appAccountDeletion: '應用程式帳號刪除',
  transactions: '交易記錄',
  appTransactions: '應用程式交易',
  appTopUps: '充值紀錄',
  rfidTransactions: 'RFID 交易',
  kioskTransactions: '付款亭交易',
  kioskSettlements: 'Octopus settlements',
  kioskAlerts: 'Kiosk alerts',
  kioskReleases: 'Kiosk releases',
  kioskReleaseKey: 'Release key',
  kioskGroups: 'Kiosk groups',
  analytics: '分析報表',
  reports: '報表',
  security: '安全管理',
  rolesPermissions: '角色與權限',
  feeManagement: '費用管理',
  feeCalculator: '費用計算器',
  pricingViewer: '定價檢視器',
  paymentSettings: '支付設定',
  contentManagement: '內容管理',
  cronMonitor: '任務監控',
  marketing: '行銷推廣',
  notifications: '通知',
  messages: '訊息',
  banners: '橫幅',
  promotions: '促銷活動與優惠券',
  notificationGroups: '通知群組',
  notificationLogs: '通知記錄',
  emailProviderRouting: '電郵服務商路由',
  logs: '日誌',
  ocppLogs: 'OCPP 日誌',
  aiTroubleshooting: 'AI 疑難排解',
  reservations: '預約',
  reservationsCalendar: '行事曆檢視',
  reservationsList: '預約列表',
  reservationPolicies: '預約政策',
  userGroups: '用戶群組',
};